/// <amd-module name="Core/Medius.Core.Web/Scripts/errorPages/NotFound"/>
import * as React from "react";
import Card from "Core/Medius.Core.Web/Scripts/components/card/Card";
import {toAction} from "Core/Medius.Core.Web/Scripts/Medius/lib/path";
import {translate} from "Core/Medius.Core.Web/Scripts/lib/globalization";

export default function NotFoundPage() {
    return (
        <Card>
            <div className="card-content">
                <div className="card-message">
                    {translate("#Core/notFoundInformation")}
                </div>
                    
                <form action={toAction('SwitchProvider', '~/Account')}>
                    <button className="card-button card-button" type="submit">{translate("#Core/logOut")}</button>
                </form>
            </div>
        </Card>
    );
}
